import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { GruposReservasProvider } from '../../providers/gruposReservas/gruposReservas'
import { LoadingController } from 'ionic-angular';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-grupos-reservas',
  templateUrl: 'grupos-reservas.html',
  providers: [ AuthService,ElectronService, GruposReservasProvider ]
})
export class GruposReservasPage {

  gruposReservas = []
  nombreGrupoReserva
  gruposReservasId
  loader
  editarProducto
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null
  modo:boolean = MODO_DESCONECTADO === undefined ? true : MODO_DESCONECTADO
  uuId
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: GruposReservasProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public mensaje: UtilsProvider,
    private _electronService: ElectronService
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          let tmodo = MODO_DESCONECTADO

          if(tmodo){
            let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-gruposReservas',RUTA_MODO_DESCONECTADO)
            if(resultado){
              this.gruposReservas = []
              this.gruposReservas = JSON.parse(resultado)
            }

          }else{
            this.cargarReservas()
          }
        }
      })

  }

  cargarReservas() {
    this.gruposReservas = []

    this.servicio.buscarGruposReservasCompaniasId(this.companiasId)
    .subscribe(
      (res: any) => {
        if(NUBE_AWS) {
          this.gruposReservas =  JSON.parse(res['_body']).data[0]
        } else {
          this.gruposReservas = res
        }
        },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar los grupos reservas, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
  }

  guardar() {

    this.loader = this.loadingCtrl.create({});
    this.loader.present();

    let datosProducto: any = {
      nombreGrupoReserva: this.nombreGrupoReserva,
      gruposReservasId: this.gruposReservasId == undefined ? "0" : this.gruposReservasId,
      uuId:this.uuId
    }

    this.storage.get('companiasId').then((val) => {
      datosProducto['companiasId'] = val
      if(MODO_DESCONECTADO){
        let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosProducto,'c:\\bd','gruposReservas')
           let valoresnuevos = resultado
           this.limpiar()
           this.loader.dismiss()

            let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-gruposReservas',RUTA_MODO_DESCONECTADO)
            if(resultadoNuevo){
              this.gruposReservas = []
              this.gruposReservas = JSON.parse(resultadoNuevo)
           }

      }else{
      if(this.editarProducto){
        this.editarProducto = false;
        this.editarProduct(datosProducto)
      } else {
        this.guardarProducto(datosProducto)
      }
    }
    });
  }

  editarProduct(datosProducto) {
    datosProducto['gruposReservasId'] = this.gruposReservasId

          let datos: any = {
            companiasId: datosProducto.companiasId,
            queHago: "A",
            nombreTabla: "gruposReservas",
            name: "dataDynamicCrud",
            gruposReservasId: datosProducto.gruposReservasId,
            nombreGrupoReserva:datosProducto.nombreGrupoReserva,
            prioridad: 0
          }
          this.servicio.actualizar(datos).subscribe((data)=> {
            this.mensaje.mensajeMuestro('Grupos reserva','Grupo actualizado con Éxito!','success')
            this.procesarResultado()
          }, (err) => {
            this.mensaje.mensajeMuestro('Grupos reserva','No se pudo actualizar el grupo reserva, intente luego','error')
            this.procesarResultado()
          })

    }

 guardarProducto(datosProducto){
   let datos: any = {
          companiasId: datosProducto.companiasId,
          queHago: "I",
          nombreTabla: "gruposReservas",
          name: "dataDynamicCrud",
          gruposReservasId: datosProducto.gruposReservasId,
          nombreGrupoReserva:datosProducto.nombreGrupoReserva,
          prioridad: 0
        }
        this.servicio.guardar(datos).subscribe((data: any)=> {
          this.mensaje.mensajeMuestro('Grupos reservas','Grupos reservas  almacenado con Éxito!','success')
          this.procesarResultado()
        },(error) => {
        console.log('error', error)
        this.mensaje.mensajeMuestro('Grupos resrvas','No se pudo guardar el grupo reserva, intente luego',error)
        this.procesarResultado()
      })
  }

  limpiar() {
    this.nombreGrupoReserva = ""
    this.gruposReservasId = 0
    this.uuId = undefined
  }

  editar(item){
    this.nombreGrupoReserva = item.nombreGrupoReserva
    this.gruposReservasId = item.gruposReservasId
    this.editarProducto = true
    this.uuId = item.uuid
  }

  eliminar(item) {
    this.mensaje.mensajeConfirmacionDos('Grupos reservas','¿Está seguro de eliminar el registro?','question','Si','No')
    .then((laRespuesta: boolean) =>{
      if (laRespuesta){
        this.loader = this.loadingCtrl.create({});
        this.loader.present();
        if(MODO_DESCONECTADO === undefined){
          this.modo = true
        }else{
          this.modo = MODO_DESCONECTADO
        }
        if(this.modo){
          let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-gruposReservas-eliminar',item)
          if(resultadoNuevo){

            this.limpiar()
            this.loader.dismiss()
            this.gruposReservas = []

            let valores = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-gruposReservas')
            if(valores){
              this.gruposReservas = JSON.parse(valores)
            }
          }
        }else{
          this.servicio.eliminar(item)
          .subscribe(
          res => {
            this.mensaje.mensajeMuestro('Grupos reserva','Registro eliminado con Éxito!','success')
            this.procesarResultado()
          },
          err => {
            this.procesarResultado()
            this.mensaje.mensajeMuestro('Grupos reserva','No se pudo eliminar el grupos reserva, intente luego','error')
          }
          )
        }
      }
      else {
        this.limpiar()
        this.cargarReservas()
        this.mensaje.mensajeMuestro('Grupos reserva','No se eliminó el registro','warning')
      }
    })
  }

  procesarResultado() {
    this.limpiar()
    this.loader.dismiss()
    this.cargarReservas()
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();

    this.loader.dismiss()
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/grupos-reservas/grupos-reservas.ts